module.exports = __webpack_public_path__ + "img/ViewQuiltOutlined.2c220b21.svg";